import { NavLink } from "react-router-dom"
import React from "react"

export default function BottomNav() {
  return (
    <div>
      <nav className="bottom-nav">
        {/* Home Icon */}
        <NavLink to="/" exact activeClassName="active">
          <div className="b-n-icon">
            <ion-icon name="storefront-outline"></ion-icon>
            <code>Store</code>
          </div>
        </NavLink>
        {/* Cart Icon */}
        <NavLink to="/explore" activeClassName="active">
          <div className="b-n-icon">
            <ion-icon name="grid-outline"></ion-icon>
            <code>Explore</code>
          </div>
        </NavLink>
        {/* Search Icon */}
        <NavLink to="/search" activeClassName="active">
          <div className="b-n-icon">
            <ion-icon name="search"></ion-icon>
            <code>Search</code>
          </div>
        </NavLink>
        {/* Store Locator */}
        <NavLink to="/my-basket" activeClassName="active">
          <div className="b-n-icon">
            <ion-icon name="basket-outline"></ion-icon>
            <code>Basket</code>
          </div>
        </NavLink>
        {/* Profile */}
        <NavLink to="/profile" activeClassName="active">
          <div className="b-n-icon">
            <ion-icon name="person-outline"></ion-icon>
            <code>Profile</code>
          </div>
        </NavLink>
      </nav>
    </div>
  )
}
